import { useRef } from "react";

export const generateSrcSet = (image?: string) => {
  if (image) {
    const sizes = ["1600w", "1280w", "960w", "640w", "320w", "142w"];
    return sizes.map((size) => `${image.replaceAll("default", size)} ${size}`).join(",");
  }
  return undefined;
};

export const useDebounce = () => {
  const ref = useRef<NodeJS.Timeout | null>(null);

  return (callback: () => void, delay: number, cleanup?: () => void) => {
    if (ref.current) clearTimeout(ref.current);
    ref.current = setTimeout(callback, delay);
    return () => {
      if (ref.current) clearTimeout(ref.current);
      cleanup?.();
    };
  };
};

export const scrollIntoView = (index: number) => {
  document.getElementById(`gallery-image-${index}`)?.scrollIntoView({ block: "nearest" });
};

export const scrollAdIntoView = () => {
  const el = document.getElementById("gallery-ad");
  el?.scrollIntoView({ block: "nearest" });
};

export const hasAdSlide = () => {
  const el = document.getElementById("gallery-ad") as HTMLElement | null;
  if (!el) return false;

  const cs = window.getComputedStyle(el);
  // Treat as present only if it participates in layout
  const visible = cs.display !== "none" && cs.visibility !== "hidden";
  const hasBox = el.offsetWidth > 0 && el.offsetHeight > 0;

  return visible && hasBox;
};
